// Analytics event names. Kept in lockstep with the mobile app's constants in
// clubbie-mobile/redux/actionNames/googleAnaliticsActions.js so events from
// both clients land in the same GA4 property under the same names.

// --- Auth (synced with mobile) ----------------------------------------------
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const SIGNUP_COMPLETED = 'SIGNUP_COMPLETED';
export const GOOGLE_REG_COMPLETED = 'GOOGLE_REG_COMPLETED';
export const APPLE_REG_COMPLETED = 'APPLE_REG_COMPLETED';
export const EMAIL_REG_COMPLETED = 'EMAIL_REG_COMPLETED';
export const PHONE_REG_COMPLETED = 'PHONE_REG_COMPLETED';

// --- Auth (web-specific additions) ------------------------------------------
export const LOGOUT = 'LOGOUT';
export const PASSWORD_RESET_REQUESTED = 'PASSWORD_RESET_REQUESTED';
export const PASSWORD_RESET_COMPLETED = 'PASSWORD_RESET_COMPLETED';

// --- Organisation -----------------------------------------------------------
export const ORGANISATION_CREATED = 'ORGANISATION_CREATED';
export const ORGANISATION_MEMBER_ADDED = 'ORGANISATION_MEMBER_ADDED';
export const ORGANISATION_MEMBER_REMOVED = 'ORGANISATION_MEMBER_REMOVED';

// --- Competitions (web-specific) --------------------------------------------
export const COMPETITION_CREATED = 'COMPETITION_CREATED';
export const TOURNAMENT_WIZARD_STEP_COMPLETED = 'TOURNAMENT_WIZARD_STEP_COMPLETED';
export const PARTICIPANT_ADDED = 'PARTICIPANT_ADDED';
export const FORMAT_CREATED = 'FORMAT_CREATED';
export const FIXTURES_GENERATED = 'FIXTURES_GENERATED';
export const FIXTURE_CREATED = 'FIXTURE_CREATED';
export const FIXTURE_EDITED = 'FIXTURE_EDITED';
export const RESULT_RECORDED = 'RESULT_RECORDED';

// --- Payments ---------------------------------------------------------------
export const TEAM_REGISTRATION_PAID = 'TEAM_REGISTRATION_PAID';

// --- Public view ------------------------------------------------------------
export const PUBLIC_VIEW_VIEWED = 'PUBLIC_VIEW_VIEWED';

// --- Tournament wizard step names (spec's 13) ------------------------------
export const WIZARD_STEP = {
  TOURNAMENT_NAME: 'tournament_name',
  TOURNAMENT_LOGO: 'tournament_logo',
  CHOOSE_SPORT: 'choose_sport',
  CHOOSE_TOURNAMENT: 'choose_tournament',
  CHOOSE_DURATION_TYPE: 'choose_duration_type',
  CHOOSE_VENUE_TYPE: 'choose_venue_type',
  CHOOSE_RESULT_MANAGEMENT: 'choose_result_management',
  SET_MATCH_RULES: 'set_match_rules',
  SET_MATCH_SCHEDULE: 'set_match_schedule',
  CREATE_TOURNAMENT_DIVISION: 'create_tournament_division',
  TEAM_REGISTRATION_FEE: 'team_registration_fee',
  TEAM_COUNT: 'team_count',
  CREATE_TOURNAMENT_GROUPS: 'create_tournament_groups',
};

// --- Param value enums ------------------------------------------------------
export const LOGIN_METHOD = {
  GOOGLE: 'google',
  APPLE: 'apple',
  EMAIL: 'email',
  PHONE: 'phone',
};

export const PARTICIPANT_TYPE = {
  CUSTOM_TEAM: 'custom-team',
  CLUBBIE_TEAM: 'clubbie-team',
  COMPETITION_ADMIN: 'competition-admin',
  COMPETITION_REFEREE: 'competition-referee',
};

export const GENERATION_MODE = {
  AUTO: 'auto',
  MANUAL: 'manual',
};

// Map a login method to the matching per-method signup event constant.
export const SIGNUP_EVENT_BY_METHOD = {
  [LOGIN_METHOD.GOOGLE]: GOOGLE_REG_COMPLETED,
  [LOGIN_METHOD.APPLE]: APPLE_REG_COMPLETED,
  [LOGIN_METHOD.EMAIL]: EMAIL_REG_COMPLETED,
  [LOGIN_METHOD.PHONE]: PHONE_REG_COMPLETED,
};
